import React, { useState, useRef, useEffect } from "react";
import Header from "../../Layout/Header";
import Sidebar from "../../Layout/Sidebar";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import toast from "react-hot-toast";
import { SERVER_URL } from "../../../config";
import { useNavigate, useLocation } from "react-router-dom";

export default function Player_profile() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const playerID = queryParams.get("player");

  const [isActive, setActive] = useState("div9");

  const [dietFile, setDietFile] = useState(null);
  const [soccerFile, setSoccerFile] = useState(null);
  const [fitnessFile, setFitnessFile] = useState(null);
  const [footballgenFile, setFootballgenFile] = useState(null);

  const dietInputRef = useRef(null);
  const soccerInputRef = useRef(null);
  const fitnessInputRef = useRef(null);
  const footballgenInputRef = useRef(null);

  
  const handleDietChange = (e) => setDietFile(e.target.files[0]);
  const handleSoccerChange = (e) => setSoccerFile(e.target.files[0]);
  const handleFitnessChange = (e) => setFitnessFile(e.target.files[0]);
  const handleFootballgenChange = (e) => setFootballgenFile(e.target.files[0]);


  const removeDietFile = () => setDietFile(null);
  const removeSoccerFile = () => setSoccerFile(null);
  const removeFitnessFile = () => setFitnessFile(null);
  const removeFootballgenFile = () => setFootballgenFile(null);


  const [userData, setUserData] = useState([]);
  const [nutritentData, setNutritentData] = useState([]);
  const [bodyCompositionData, setBodyCompositionData] = useState([]);
  const [intoleranceData, setIntoleranceData] = useState([]);
  const [foodRecommendData, setFoodRecommendData] = useState([]);
  const [foodAvoidData, setFoodAvoidData] = useState([]);

  const [behavioralTraits, setBehavioralTraits] = useState([]);
  const [injuryRisks, setInjuryRisks] = useState([]);
  const [muscularTraits, setMuscularTraits] = useState([]);
  const [psychiatricTraits, setPsychiatricTraits] = useState([]);
  const [sportsTraits, setSportsTraits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportStatus, setReportStatus] = useState({
    diet_uploaded: false,
    soccer_uploaded: false,
    fitness_uploaded: false,
    footballgen_uploaded: false
  });

  const fetchDietReport = async () => {
    try {
      const response = await axios.get(
        `${SERVER_URL}/api/admin/get-user-diet-report?player_id=${playerID}`
      );

      if (response.data.status) {
        const data = response.data.data;
        setNutritentData(data.nutrient || []);
        setBodyCompositionData(data.body_composition || []);
        setIntoleranceData(data.intolerances_and_deficiencies || []);
        setFoodRecommendData(data.recommended_food || {});
        setFoodAvoidData(data.to_avoid_food || {});
      }
    } catch (error) {
      console.error("Failed to fetch diet report.", error);
      if (error?.response?.status === 403) {
        const msg = error?.response?.data?.error?.msg || "Forbidden access";

        if (
          msg.includes("expired") ||
          msg.includes("invalidated") ||
          msg.includes("Invalid token") ||
          msg.includes("token is required")
        ) {
          toast.error("Session expired. Redirecting to login...");
          setTimeout(() => navigate('/player/login'), 2000);
        }
      }

    }
  };

  const fetchSoccerReport = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/admin/get-user-soccer-report?player_id=${playerID}`);

      if (response.data.status) {
        const data = response.data.data;

        setBehavioralTraits(data["Behavioural Traits"] || []);
        setInjuryRisks(data["Injuries"] || []);
        setMuscularTraits(data["Muscular System Traits"] || []);
        setPsychiatricTraits(data["Psychiatric Traits"] || []);
        setSportsTraits(data["Sports Traits"] || []);
      }
    } catch (error) {
      console.error("Failed to fetch soccer report.", error);
      if (error?.response?.status === 403) {
        const msg = error?.response?.data?.error?.msg || "Forbidden access";

        if (
          msg.includes("expired") ||
          msg.includes("invalidated") ||
          msg.includes("Invalid token") ||
          msg.includes("token is required")
        ) {
          toast.error("Session expired. Redirecting to login...");
          setTimeout(() => navigate('/player/login'), 2000);
        }
      }
    }
  };

  const fetchReportStatus = async () => {
      try {
        const token = sessionStorage.getItem('admin_token');
        if (!token) {
          setError('No admin token found');
          setLoading(false);
          return;
        }

        const response = await fetch(`${SERVER_URL}/api/admin/player-report-status/${playerID}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (data.status) {
          setReportStatus({
            diet_uploaded: data.diet_uploaded,
            soccer_uploaded: data.soccer_uploaded,
            fitness_uploaded: data.fitness_uploaded,
            footballgen_uploaded: data.footballgen_uploaded

          });
        } else {
          setError(data.msg || 'Failed to fetch report status');
        }
      } catch (err) {
        setError('Failed to fetch report status');
      } finally {
        setLoading(false);
      }
  };



  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `${SERVER_URL}/api/admin/get-player-data?player_id=${playerID}`
        );
        if (response.data.status) {
          setUserData(response.data.data[0]);
        }
      } catch (error) {
        console.error("Failed to fetch Users list.", error);
        if (error?.response?.status === 403) {
          const msg = error?.response?.data?.error?.msg || "Forbidden access";

          if (
            msg.includes("expired") ||
            msg.includes("invalidated") ||
            msg.includes("Invalid token") ||
            msg.includes("token is required")
          ) {
            toast.error("Session expired. Redirecting to login...");
            setTimeout(() => navigate('/player/login'), 2000);
          }
        }
      }
    };


    if (playerID) {
      fetchUserData();
      fetchDietReport();
      fetchSoccerReport();
      fetchReportStatus();
    }
  }, [playerID]);

  const handleActivetab = (tab) => {
    setActive(tab);
  };

  const handleSubmit = async (file, category) => {
    if (!file) {
      toast.error(`Select the ${category} report PDF`);
      return false;
    }

    const fileName = file.name;

    const validEndings = {
      diet: "_Nutrition.pdf",
      soccer: "_Soccer.pdf",
      fitness: "_Fitness.pdf",
      footballgen: "_Footballgen.pdf",
    };
    console.log(fileName);

    const expectedEnding = validEndings[category];
    if (!fileName.endsWith(expectedEnding)) {
      toast.error(`Filename must end with "${expectedEnding}"`);
      return false;
    }

    const formData = new FormData();
    formData.append("pdf", file);
    formData.append("id", playerID);
    formData.append("name", userData.full_name || "Unknown Player");
    formData.append("category", category);

    const toastId = toast.loading(`${category} report uploading...`);

    try {
      await axios.post(`${SERVER_URL}/api/admin/get-user-upload`, formData);
      toast.success(`${category} report uploaded successfully!`, { id: toastId });

      if (category === "diet") setDietFile(null);
      if (category === "soccer") setSoccerFile(null);
      if (category === "fitness") setFitnessFile(null);
      if (category === "footballgen") setFootballgenFile(null);

      fetchDietReport();
      fetchSoccerReport();

    } catch (error) {
      toast.error("Upload failed", { id: toastId });
      console.error(error);
    }
  };

  const options = [
    { value: "too_high", label: "Too High" },
    { value: "high", label: "High" },
    { value: "medium", label: "Medium" },
    { value: "low", label: "Low" },
    { value: "too_low", label: "Too Low" },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      border: "none",
      boxShadow: "none",
      padding: "6px 12px",
      borderRadius: "0.5rem",
      color: "white",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "rgba(30, 30, 30, 0.95)",
      color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "rgba(255,255,255,0.2)"
        : "transparent",
      color: "white",
      cursor: "pointer",
    }),
    input: (provided) => ({
      ...provided,
      color: "white",
    }),
  };

  const SectionList = ({ data }) => (
    <div className="flex flex-col gap-y-5 text-white text-[16px]">
      {data.map((item, index) => (
        <div
          key={index}
          className="flex flex-col lg:flex-row lg:items-start gap-y-3 lg:gap-x-4"
        >
          <div className="w-full lg:w-[25%]">
            <label className="text-[15px] font-medium text-gray-300 break-words">
              {item.Condition} :
            </label>
          </div>
          <div className="w-full lg:w-[25%]">
            <p
              className="w-full px-3 py-2 rounded-md border border-gray-300 bg-white text-black text-[15px] font-medium"
              style={{ ...customStyles?.control?.() }}
            >
              {item["Risk factor"] ?? "-"}
            </p>
          </div>
          <div className="w-full lg:w-[50%]">
            <p className="w-full py-2 border-b border-dashed text-[15px] text-white leading-snug">
              {item.Recommendations ?? "-"}
            </p>
          </div>
        </div>
      ))}
    </div>
  );

  const SectionListSoccer = ({ data }) => (
    <div className="flex flex-col gap-y-5 text-white text-[16px]">
      {data.map((item, index) => (
        <div
          key={index}
          className="flex flex-col lg:flex-row lg:items-start gap-y-3 lg:gap-x-4"
        >
          <div className="w-full lg:w-[50%]">
            <label className="text-[15px] font-medium text-gray-300 break-words">
              {item.Condition} :
            </label>
          </div>
          <div className="w-full lg:w-[50%]">
            <p
              className="w-full px-3 py-2 rounded-md border border-gray-300 bg-white text-black text-[15px] font-medium"
              style={{ ...customStyles?.control?.() }}
            >
              {item.Risk ?? "-"}
            </p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div
      className="min-h-screen lg:h-screen flex flex-col bg-cover bg-no-repeat text-white"
      style={{ backgroundImage: 'url("/assets/bg/adminbg.svg")' }}
    >
      <Header />
      <div className="flex flex-col lg:flex-row flex-grow overflow-hidden">
        <Sidebar />
        <div className="lg:w-[80%] overflow-y-auto p-5">
          <p className="text-xl font-bold mb-4">Player Profile</p>
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div>
              <div className="w-40 h-48 border rounded-md">
                <img
                  src="/assets/player/player1.svg"
                  className="object-cover h-full rounded-md mx-auto"
                ></img>
              </div>
            </div>
            <div className="lg:w-[75%] space-y-3 lg:space-y-7">
              <div className="text-lg flex flex-col lg:flex-row gap-3 lg:gap-0 justify-between">
                <div className="flex flex-col lg:flex-row lg:gap-1 lg:w-[50%]">
                  <label className="lg:w-[30%] uppercase">Name :</label>
                  <p className="font-bold">{userData.full_name}</p>
                </div>
                <div className="flex flex-col lg:flex-row lg:gap-10 lg:w-[50%]">
                  <label className="lg:w-[30%] uppercase">Kit Number :</label>
                  <p className="font-bold">Goaldex_{playerID}</p>
                </div>
              </div>
              <div className="text-lg flex flex-col lg:flex-row gap-3 lg:gap-0 justify-between">
                <div className="flex flex-col lg:flex-row lg:gap-1 lg:w-[50%]">
                  <label className="lg:w-[30%] uppercase">Email ID :</label>
                  <p className="font-bold">{userData.email}</p>
                </div>
                {/* <div className='flex flex-col lg:flex-row lg:gap-10 lg:w-[50%]'>
                  <label className='lg:w-[30%] uppercase'>MOBILE NO :</label>
                  <p className='font-bold'>+91 9346552742</p>
                </div> */}
              </div>
              <div className="flex flex-col lg:flex-row items-center gap-5">
                <button className="pl-5 p-[1px] border-2 rounded-full font-bold flex items-center">
                  EDIT INFO
                  <div className="ml-3 py-2 px-2 rounded-full bg-white">
                    <img
                      src="/assets/icon/pen.svg"
                      className="translate-y-[2px] translate-x-[2px"
                    ></img>
                  </div>
                </button>
                <button className="pl-5 p-[1px] border-2 rounded-full font-bold flex items-center">
                  CHANGE PROFILE PICTURE
                  <div className="ml-3 py-2 px-2 rounded-full bg-white">
                    <img src="/assets/icon/edit.svg"></img>
                  </div>
                </button>

                {/* <label className="pl-5 p-[1px] border-2 rounded-full font-bold flex items-center cursor-pointer max-w-full relative">
                  <div className="truncate max-w-[200px]">
                    {pdfFile ? pdfFile.name : "UPLOAD  REPORT"}
                  </div>

                  <div className="ml-3 py-2 px-2 rounded-full bg-white shrink-0">
                    <img
                      src="/assets/icon/pen.svg"
                      className="translate-y-[2px] translate-x-[2px]"
                      alt="pen icon"
                    />
                  </div>

                  <input
                    type="file"
                    accept="application/pdf"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                </label>

                {pdfFile && (
                  <button
                    type="button"
                    title="Remove file"
                    onClick={handleRemove}
                    className="text-red-500 cursor-pointer text-3xl font-bold focus:outline-none"
                  >
                    ×
                  </button>
                )}

                {pdfFile && (
                  <button
                    onClick={handleSubmit}
                    className="text-white bg-[#D9D9D961] cursor-pointer px-4 py-2 rounded-full font-semibold"
                  >
                    Submit PDF
                  </button>
                )} */}
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="relative">
              <div
                className="flex flex-wrap divide-x divide-white/0 lg:flex-nowrap text-nowrap flex-row justify-center lg:justify-start items-center text-lg relative overflow-x-auto overflow-hidden"
                style={{ zIndex: 1 }}
              >
                {/* <a className={`px-4 py-2 ${isActive === 'div1' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div1')}>
                  Sports Traits
                </a>
                <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div1' ? 'bg-white' : 'bg-gray-500'}`}></div>
                <a className={`px-4 py-2 ${isActive === 'div2' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div2')}>
                  Psychiatric Traits
                </a>
                <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div2' ? 'bg-white' : 'bg-gray-500'}`}></div>
                <a className={`px-4 py-2 ${isActive === 'div3' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div3')}>
                  Muscular System Traits
                </a>
                <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div3' ? 'bg-white' : 'bg-gray-500'}`}></div>
                <a className={`px-4 py-2 ${isActive === 'div4' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div4')}>
                  Injuries
                </a>
                <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div4' ? 'bg-white' : 'bg-gray-500'}`}></div>
                <a className={`px-4 py-2 ${isActive === 'div5' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div5')}>
                  Behavioural Traits
                </a> */}
                {/* <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div5' ? 'bg-white' : 'bg-gray-500'}`}></div> */}

                <a className={`px-4 py-2 ${isActive === 'div9' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div9')}>
                  Upload Reports
                </a>
                
                <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div9' ? 'bg-white' : 'bg-gray-500'}`}></div>
         {/*
                <a
                  className={`px-4 py-2 ${isActive === "div6"
                    ? "border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0" : ""}`}
                  onClick={() => handleActivetab("div6")}>
                  Nutrition Panel
                </a>
                <div
                  className={`lg:h-6 lg:w-[1px] ${isActive === "div6" ? "bg-white" : "bg-gray-500"}`}></div>
                <a className={`px-4 py-2 ${isActive === "div7"
                  ? "border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0" : ""}`}
                  onClick={() => handleActivetab("div7")}>
                  Genetic Grocery
                </a>
                <div
                  className={`lg:h-6 lg:w-[1px] ${isActive === "div7" ? "bg-white" : "bg-gray-500"}`}></div>
                <a className={`px-4 py-2 ${isActive === "div10"
                  ? "border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0" : ""}`}
                  onClick={() => handleActivetab("div10")}>
                  DNA Data
                </a>
              <div className={`lg:h-6 lg:w-[1px] ${isActive === 'div7' ? 'bg-white' : 'bg-gray-500'}`}></div>
                <a className={`px-4 py-2 ${isActive === 'div8' ? 'border-white bg-white/10 lg:bg-white/0 rounded-md lg:rounded-none lg:border-b-[4px] border-r-0' : ''}`} onClick={() => handleActivetab('div8')}>
                  Behavioural Traits
                </a> */}
              </div>
              <div
                className="w-full lg:h-[4px] rounded bg-gray-500 absolute bottom-0"
                style={{ zIndex: 0 }}
              ></div>
            </div>
            <div className="mt-5 bg-white/10 rounded-xl py-5 px-10">

              {isActive === "div1" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-1/2">
                      Elite Athlete:
                    </label>
                    <div className="w-full">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-1/2">
                      Football/Soccer:
                    </label>
                    <div className="w-full">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-1/2">
                      Sprint:
                    </label>
                    <div className="w-full">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-1/2">
                      Respiratory Gains:
                    </label>
                    <div className="w-full">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-1/2">
                      Runner:
                    </label>
                    <div className="w-full">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}
              {isActive === "div2" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrapw-full lg:w-1/2">
                      Lack of Focus :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrapw-full lg:w-1/2">
                      Pleasantness :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrapw-full lg:w-1/2">
                      Type A Personality :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrapw-full lg:w-1/2">
                      Type D Personality :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrapw-full lg:w-1/2">
                      Learning from Mistakes :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}
              {isActive === "div3" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Neuromuscular Strength :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Skeletal Muscle Contraction :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Transversal Physiological :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-now w-full lg:w-1/2">
                      Quadriceps Muscle Strength :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Hand Grip Strength :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Knee Strength :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full w-full lg:w-1/2">
                      Biceps Increase  :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}
              {isActive === "div4" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Achilles Tendon Injury :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Probability of Muscle Injuries :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Hamstring Injuries :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-now w-full lg:w-1/2">
                      Induced Muscle Damage :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Meniscus Injury :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Ligament Rupture  :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}
              {isActive === "div5" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Obsessive Behavior :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Impulsivity :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Aggressiveness :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-now w-full lg:w-1/2">
                      Shyness :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center justify-between gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap w-full lg:w-1/2">
                      Bipolar Disorder :
                    </label>
                    <div className="w-full lg:w-1/2">
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}

              {isActive === "div6" && (
                <div className="flex flex-col gap-y-10 text-white text-[16px]">
                  {nutritentData.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Nutrient Recommendations
                      </h2>
                      <SectionList data={nutritentData} />
                    </div>
                  )}
                  {bodyCompositionData.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Body Composition Recommendations
                      </h2>
                      <SectionList data={bodyCompositionData} />
                    </div>
                  )}
                  {intoleranceData.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Intolerances & Deficiencies
                      </h2>
                      <SectionList data={intoleranceData} />
                    </div>
                  )}
                  {nutritentData.length === 0 &&
                    bodyCompositionData.length === 0 &&
                    intoleranceData.length === 0 && (
                      <div className="text-center text-white p-10">
                        <p>No data found.</p>
                        <p>
                          Please upload your nutrition report to see
                          recommendations.
                        </p>
                      </div>
                    )}
                </div>
              )}

              {isActive === "div7" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-7 text-white text-[16px]">
                  <div>
                    <p className="font-bold text-yellow-400 text-lg text-center mb-3">
                      Foods To Consume
                    </p>
                    <div className="border rounded-3xl p-5 min-h-[200px] flex flex-col gap-4">
                      {Object.keys(foodRecommendData).length > 0 ? (
                        Object.entries(foodRecommendData).map(
                          ([category, items]) => (
                            <div key={category}>
                              <p className="text-base font-bold text-white mb-1">
                                {category} :
                              </p>
                              <p className="text-white text-[15px] leading-relaxed break-words">
                                {items.join(", ")}
                              </p>
                            </div>
                          )
                        )
                      ) : (
                        <p>No data available.</p>
                      )}
                    </div>
                  </div>

                  <div>
                    <p className="font-bold text-yellow-400 text-lg text-center mb-3">
                      Foods To Avoid
                    </p>
                    <div className="border rounded-3xl p-5 min-h-[200px] flex flex-col gap-4">
                      {Object.keys(foodAvoidData).length > 0 ? (
                        Object.entries(foodAvoidData).map(
                          ([category, items]) => (
                            <div key={category}>
                              <p className="text-base font-bold text-white mb-1">
                                {category} :
                              </p>
                              <p className="text-white text-[15px] leading-relaxed break-words">
                                {items.join(", ")}
                              </p>
                            </div>
                          )
                        )
                      ) : (
                        <p>No data available.</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {isActive === "div8" && (
                <div className="grid grid-cols-1 gap-y-7 text-white">
                  <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap">
                      Maintaining Body Weight :
                    </label>
                    <div>
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap">
                      Recommendation :
                    </label>
                    <input className="w-[100%] border-b border-dashed outline-none"></input>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap">
                      limming with more Fiber Intake :
                    </label>
                    <div>
                      <Select
                        options={options}
                        styles={customStyles}
                        defaultValue={options[0]}
                        isSearchable={false}
                      />
                    </div>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap">
                      Recommendation :
                    </label>
                    <input className="w-[100%] border-b border-dashed outline-none"></input>
                  </div>

                  <div className="flex flex-col lg:flex-row items-center gap-2 lg:gap-4">
                    <label className="text-lg font-medium whitespace-nowrap">
                      Upload Full DNA Report :
                    </label>
                    <input
                      className="bg-white/10 rounded-md px-5 py-2"
                      type="file"
                    ></input>
                  </div>
                </div>
              )}

              {isActive === "div9" && (
                <div className="flex flex-col gap-y-5 text-white">

                  <div className="flex flex-row items-center gap-4 flex-wrap lg:flex-nowrap">
                    <label className="text-lg font-medium whitespace-nowrap min-w-[160px]">
                      Diet Report:
                    </label>

                   {reportStatus.diet_uploaded ? (
                    <span className="text-lg font-medium text-green-400">
                      Diet report has been successfully uploaded for this player.
                    </span>
                  ) : (
                    <>
                    <label className="pl-6 py-[4px] border rounded-full font-bold flex items-center cursor-pointer w-51 relative">
                      <span className="whitespace-nowrap">UPLOAD REPORT</span>
                      <div className="ml-3 py-2 px-2 rounded-full bg-white shrink-0">
                        <img
                          src="/assets/icon/pen.svg"
                          className="translate-y-[2px] translate-x-[2px]"
                          alt="pen icon"
                        />
                      </div>
                      <input
                        type="file"
                        accept="application/pdf"
                        className="hidden"
                        ref={dietInputRef}
                        onChange={handleDietChange}
                      />
                    </label>

                    {dietFile && (
                      <>
                        <span className="truncate max-w-[200px] text-s font-bold">{dietFile.name}</span>
                        <button
                          type="button"
                          title="Remove file"
                          onClick={removeDietFile}
                          className="text-red-500 cursor-pointer text-3xl font-bold focus:outline-none"
                        >
                          ×
                        </button>
                        <button
                          onClick={() => handleSubmit(dietFile, "diet")}
                          className="text-white bg-[#D9D9D961] cursor-pointer px-4 py-2 rounded-full font-semibold whitespace-nowrap"
                        >
                          Submit PDF
                        </button>
                      </>
                    )}
                     </>
                  )}
                  </div>

                  <div className="flex flex-row items-center gap-4 flex-wrap lg:flex-nowrap">
                    <label className="text-lg font-medium whitespace-nowrap min-w-[160px]">
                      Soccer Report:
                    </label>
                  {reportStatus.soccer_uploaded ? (
                    <span className="text-lg font-medium text-green-400">
                      Soccer report has been successfully uploaded for this player.
                    </span>
                  ) : (
                    <>
                    <label className="pl-6 py-[4px] border rounded-full font-bold flex items-center cursor-pointer w-51 relative">
                      <span className="whitespace-nowrap">UPLOAD REPORT</span>
                      <div className="ml-3 py-2 px-2 rounded-full bg-white shrink-0">
                        <img
                          src="/assets/icon/pen.svg"
                          className="translate-y-[2px] translate-x-[2px]"
                          alt="pen icon"
                        />
                      </div>
                      <input
                        type="file"
                        accept="application/pdf"
                        className="hidden"
                        ref={soccerInputRef}
                        onChange={handleSoccerChange}
                      />
                    </label>

                    {soccerFile && (
                      <>
                        <span className="truncate max-w-[200px] text-s font-bold">{soccerFile.name}</span>
                        <button
                          type="button"
                          title="Remove file"
                          onClick={removeSoccerFile}
                          className="text-red-500 cursor-pointer text-3xl font-bold focus:outline-none"
                        >
                          ×
                        </button>
                        <button
                          onClick={() => handleSubmit(soccerFile, "soccer")}
                          className="text-white bg-[#D9D9D961] cursor-pointer px-4 py-2 rounded-full font-semibold whitespace-nowrap"
                        >
                          Submit PDF
                        </button>
                      </>
                    )}
                   </>
                  )}
                  </div>

                  <div className="flex flex-row items-center gap-4 flex-wrap lg:flex-nowrap">
                    <label className="text-lg font-medium whitespace-nowrap min-w-[160px]">
                      Fitness Report:
                    </label>
                    {reportStatus.fitness_uploaded ? (
                    <span className="text-lg font-medium text-green-400">
                      Fitness report has been successfully uploaded for this player.
                    </span>
                  ) : (
                    <>
                    <label className="pl-6 py-[4px] border rounded-full font-bold flex items-center cursor-pointer w-51 relative">
                      <span className="whitespace-nowrap">UPLOAD REPORT</span>
                      <div className="ml-3 py-2 px-2 rounded-full bg-white shrink-0">
                        <img
                          src="/assets/icon/pen.svg"
                          className="translate-y-[2px] translate-x-[2px]"
                          alt="pen icon"
                        />
                      </div>
                      <input
                        type="file"
                        accept="application/pdf"
                        className="hidden"
                        ref={fitnessInputRef}
                        onChange={handleFitnessChange}
                      />
                    </label>

                    {fitnessFile && (
                      <>
                        <span className="truncate max-w-[200px] text-sm font-medium">{fitnessFile.name}</span>
                        <button
                          type="button"
                          title="Remove file"
                          onClick={removeFitnessFile}
                          className="text-red-500 cursor-pointer text-3xl font-bold focus:outline-none"
                        >
                          ×
                        </button>
                        <button
                          onClick={() => handleSubmit(fitnessFile, "fitness")}
                          className="text-white bg-[#D9D9D961] cursor-pointer px-4 py-2 rounded-full font-semibold whitespace-nowrap"
                        >
                          Submit PDF
                        </button>
                      </>
                    )}
                    </>
                  )}
                  </div>



                  <div className="flex flex-row items-center gap-4 flex-wrap lg:flex-nowrap">
                    <label className="text-lg font-medium whitespace-nowrap min-w-[160px]">
                      Football Genetics Report:
                    </label>
                    {reportStatus.footballgen_uploaded ? (
                    <span className="text-lg font-medium text-green-400">
                      Football Genetics report has been successfully uploaded for this player.
                    </span>
                  ) : (
                    <>
                    <label className="pl-6 py-[4px] border rounded-full font-bold flex items-center cursor-pointer w-51 relative">
                      <span className="whitespace-nowrap">UPLOAD REPORT</span>
                      <div className="ml-3 py-2 px-2 rounded-full bg-white shrink-0">
                        <img
                          src="/assets/icon/pen.svg"
                          className="translate-y-[2px] translate-x-[2px]"
                          alt="pen icon"
                        />
                      </div>
                      <input
                        type="file"
                        accept="application/pdf"
                        className="hidden"
                        ref={footballgenInputRef}
                        onChange={handleFootballgenChange}
                      />
                    </label>

                    {footballgenFile && (
                      <>
                        <span className="truncate max-w-[200px] text-sm font-medium">{footballgenFile.name}</span>
                        <button
                          type="button"
                          title="Remove file"
                          onClick={removeFootballgenFile}
                          className="text-red-500 cursor-pointer text-3xl font-bold focus:outline-none"
                        >
                          ×
                        </button>
                        <button
                          onClick={() => handleSubmit(footballgenFile, "footballgen")}
                          className="text-white bg-[#D9D9D961] cursor-pointer px-4 py-2 rounded-full font-semibold whitespace-nowrap"
                        >
                          Submit PDF
                        </button>
                      </>
                    )}
                    </>
                  )}
                  </div>





                </div>
              )}

              {isActive === "div10" && (
                <div className="flex flex-col gap-y-10 text-white text-[16px]">
                  {behavioralTraits.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Behavioural Traits
                      </h2>
                      <SectionListSoccer data={behavioralTraits} />
                    </div>
                  )}

                  {injuryRisks.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Injury Risks
                      </h2>
                      <SectionListSoccer data={injuryRisks} />
                    </div>
                  )}

                  {muscularTraits.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Muscular System Traits
                      </h2>
                      <SectionListSoccer data={muscularTraits} />
                    </div>
                  )}

                  {psychiatricTraits.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Psychiatric Traits
                      </h2>
                      <SectionListSoccer data={psychiatricTraits} />
                    </div>
                  )}

                  {sportsTraits.length > 0 && (
                    <div>
                      <h2 className="text-xl font-bold text-yellow-400 mb-4">
                        Sports Traits
                      </h2>
                      <SectionListSoccer data={sportsTraits} />
                    </div>
                  )}

                  {behavioralTraits.length === 0 &&
                    injuryRisks.length === 0 &&
                    muscularTraits.length === 0 &&
                    psychiatricTraits.length === 0 &&
                    sportsTraits.length === 0 && (
                      <div className="text-center text-white p-10">
                        <p>No soccer report data found.</p>
                        <p>Please upload a valid soccer report.</p>
                      </div>
                    )}
                </div>
              )}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
